// Friends + leaderboard client.
import { API_BASE } from './chat'

export type LeaderboardEntry = {
  user_id: string; name: string; you: boolean; coins: number; streak: number; level: string; rank: number
}
export type FriendRequest = { friendship_id: number; name: string }

export async function getLeaderboard(userId: string): Promise<LeaderboardEntry[]> {
  try {
    const r = await fetch(`${API_BASE}/v1/friends/leaderboard?user_id=${encodeURIComponent(userId)}`)
    return r.ok ? (await r.json()).leaderboard : []
  } catch {
    return []
  }
}

export async function getFriendRequests(userId: string): Promise<FriendRequest[]> {
  try {
    const r = await fetch(`${API_BASE}/v1/friends/requests?user_id=${encodeURIComponent(userId)}`)
    return r.ok ? (await r.json()).requests : []
  } catch {
    return []
  }
}

export async function inviteFriend(userId: string, friendEmail: string): Promise<{ ok: boolean; error?: string }> {
  try {
    const r = await fetch(`${API_BASE}/v1/friends/invite`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId, friend_email: friendEmail }),
    })
    if (r.ok) return { ok: true }
    const d = await r.json().catch(() => ({}))
    return { ok: false, error: d.detail || 'Could not send invite.' }
  } catch {
    return { ok: false, error: 'Network error.' }
  }
}

export async function acceptFriend(friendshipId: number, userId: string): Promise<boolean> {
  try {
    const r = await fetch(`${API_BASE}/v1/friends/${friendshipId}/accept`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ user_id: userId }),
    })
    return r.ok
  } catch {
    return false
  }
}
